<ng-content></ng-content>
<label [innerHTML]="label" class="checkbox-label" [class.no-label-content]="!label" [attr.for]="_control?.id" [class.show-error-icon]="parent?.hasError"></label>